import React from 'react';
import CollectShipAddressConfig from './Configs/CollectShipAddressConfig';
import CalculateCheckTaxesConfig from './Configs/CalculateCheckTaxesConfig';
import EnsurePodCheckoutDefaults from './Configs/EnsurePodCheckoutDefaults';
import { useShopById } from '../../redux/hooks/shops';
import { isPODShop, isPopupShop } from './helpers/helpers';

const ShopCheckoutConfig = ({ shop_id }: { shop_id: string }) => {
  const shop = useShopById(shop_id);
  return (
    <div className="row">
      {isPODShop(shop) && <EnsurePodCheckoutDefaults shop_id={shop_id} />}
      {(isPopupShop(shop) || isPODShop(shop)) && <CollectShipAddressConfig shop_id={shop_id} />}
      {(isPopupShop(shop) || isPODShop(shop)) && <CalculateCheckTaxesConfig shop_id={shop_id} />}
      {/* todo: implement and add other checkout config/section components */}
    </div>
  );
};

export default ShopCheckoutConfig;
